import {ETextParamType_OperateCanvas} from './const';
import {getCanvasLayerShow} from './dataOps';
import {hel_setText} from './moduleCaller';

/**
 * TogggleDefaultで設定された値に戻す
 * @param ToggleName
 */
export const hel_canvas_ResetToggleDefault = (ToggleName: string) => {
  const layoutName = 'DummyLayout'; // 構文ルール上必要
  hel_setText(ETextParamType_OperateCanvas, 'ToggleDefault,' + layoutName + ',' + ToggleName);
};

/**
 * Toggleを切り替える
 * @param ToggleName
 */
export const hel_canvas_ToggleChange = (ToggleName: string) => {
  const layoutName = 'DummyLayout'; // 構文ルール上必要
  hel_setText(ETextParamType_OperateCanvas, 'ToggleChange,' + layoutName + ',' + ToggleName);
};

/**
 * @param layoutName
 */
export const hel_canvas_GetLayerShow = (layoutName: string) => {
  // エンジン側に問い合わせする。
  hel_setText(ETextParamType_OperateCanvas, 'GetLayerShow,' + layoutName);

  // エンジンでこの関数が呼ばれ、
  // 結果が g_CanvasLayerShow[] に入る。その値を返す。
  return getCanvasLayerShow(layoutName);
};

/**
 * @param layoutName
 * @param show
 */
export const hel_canvas_SetLayoutShow = (layoutName: string, show: boolean) => {
  hel_setText(
    ETextParamType_OperateCanvas,
    'SetLayoutShow,' + layoutName + ',' + (show ? 'true' : 'false')
  );
};

/**
 * @param layoutName
 * @param guiName
 * @param show
 */
export const hel_canvas_SetGUIShow = (layoutName: string, guiName: string, show: boolean) => {
  hel_setText(
    ETextParamType_OperateCanvas,
    'SetGUIShow,' + layoutName + ',' + guiName + ',' + (show ? 'true' : 'false')
  );
};

export const hel_chatbadge_ui_update = () => {
  // チャットログのバッジ判定＋表示
  if (typeof globalThis.hel_if_displayChatBadge === 'function') {
    globalThis.hel_if_displayChatBadge();
  } else {
    // gudのチャットログアイコンのバッジの表示設定
    hel_canvas_ResetToggleDefault('IsVisible_hud_textchatbadge'); // 初期値はfalse（＝非表示）

    if (
      hel_canvas_GetLayerShow('ChatLogView') ||
      hel_canvas_GetLayerShow('config_base') ||
      hel_canvas_GetLayerShow('photo_layer')
    ) {
      // チャットログ表示中は何もしない
      // フォトモード表示中は何もしない
    } else {
      // チャットログ横のバッジを表示させる
      hel_canvas_ToggleChange('IsVisible_hud_textchatbadge'); // trueに変更（＝表示）
      hel_canvas_SetGUIShow('HUD', 'hud_textchatbadge', true);
    }
  }
};
